var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactInfoIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26.76px",
    height: "26.758px",
    viewBox: "0 0 26.76 26.758",
    enableBackground: "new 0 0 26.76 26.758",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE600",
    d: "M23.531,25.835L23.531,25.835h-0.002H3.23c-1.271-0.002-2.305-1.036-2.308-2.305L0.924,9.837 c0.007-1.269,1.041-2.299,2.305-2.302h20.301c1.27,0.003,2.305,1.037,2.307,2.307v13.687 C25.834,24.799,24.799,25.833,23.531,25.835L23.531,25.835z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2B555F",
    d: "M23.529,0H3.23C1.447,0.004,0.004,1.448,0,3.229v20.299c0.004,1.783,1.447,3.227,3.23,3.229h20.299 c1.783-0.003,3.227-1.446,3.229-3.229h0.002V3.229C26.756,1.448,25.313,0.004,23.529,0z M24.913,23.528 c-0.002,0.756-0.629,1.383-1.384,1.385H3.23c-0.755-0.002-1.383-0.629-1.385-1.385V9.837C1.85,9.085,2.477,8.46,3.23,8.458h20.299 c0.755,0.002,1.382,0.63,1.384,1.386V23.528z M24.913,6.931c-0.42-0.2-0.888-0.316-1.384-0.317H3.23 C2.734,6.614,2.266,6.73,1.846,6.931l0.001-3.701C1.848,2.475,2.476,1.848,3.23,1.846h20.299c0.755,0.002,1.382,0.629,1.384,1.384 V6.931z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B555F",
    d: "M17.514,2.152c-1.146,0.001-2.075,0.93-2.077,2.076c0.002,1.146,0.931,2.075,2.077,2.077 c1.146-0.002,2.076-0.931,2.076-2.077S18.66,2.153,17.514,2.152z M17.515,5.112c-0.489-0.003-0.882-0.397-0.886-0.883 c0.004-0.489,0.396-0.882,0.886-0.885C18,3.348,18.394,3.74,18.398,4.229C18.394,4.715,18,5.109,17.515,5.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B555F",
    d: "M22.089,2.152c-1.147,0.001-2.075,0.93-2.077,2.076c0.002,1.146,0.93,2.075,2.077,2.077 c1.146-0.002,2.074-0.931,2.075-2.077C24.163,3.082,23.234,2.153,22.089,2.152z M22.09,5.112 c-0.489-0.003-0.883-0.397-0.885-0.883c0.002-0.489,0.396-0.882,0.885-0.885c0.486,0.003,0.879,0.396,0.884,0.885 C22.969,4.715,22.576,5.109,22.09,5.112z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfoIcon3);
export default __webpack_public_path__ + "static/media/contact-info-icon3.5dc9072ef39d52b53d3cf6ef56e2ff76.svg";
export { ForwardRef as ReactComponent };